import {
  childrenPropsSDKFactory,
  clickPropsSDKFactory,
  composeSDKFactories,
  createElementPropsSDKFactory,
  registerCorvidEvent,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import type { CorvidSDKFactory } from '@wix/editor-elements-types/corvid';
import type {
  IHamburgerMenuContainerSDK,
  IHamburgerMenuContainerProps,
} from '../HamburgerMenuContainer.props';

const hamburgerMenuSdkFactory: CorvidSDKFactory<
  IHamburgerMenuContainerProps,
  IHamburgerMenuContainerSDK
> = api => {
  const { hasResponsiveLayout } = api.props;
  let overlay;

  if (hasResponsiveLayout) {
    overlay = api.metaData.getParent();
  } else {
    const column = api.metaData.getParent();
    const strip = column.parent;
    overlay = strip.parent;
  }

  const rootSDK = overlay.parent;
  const { _getIsMenuOpen, _setIsMenuOpen } = rootSDK;

  return {
    get opened() {
      return _getIsMenuOpen();
    },
    async open() {
      _setIsMenuOpen(true);
    },
    async close() {
      _setIsMenuOpen(false);
    },
    onOpen: cb => registerCorvidEvent('onOpen', api, cb),
    onClose: cb => registerCorvidEvent('onClose', api, cb),
  };
};

const elementPropsSDKFactory = createElementPropsSDKFactory({
  useHiddenCollapsed: false,
});

export const sdk = composeSDKFactories<
  IHamburgerMenuContainerProps,
  IHamburgerMenuContainerSDK
>([
  hamburgerMenuSdkFactory,
  elementPropsSDKFactory,
  childrenPropsSDKFactory,
  clickPropsSDKFactory,
]);

export default createComponentSDKModel(sdk);
